// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-swbl-szjdLstd-index-main_right_content-WlnVh","table":"components-swbl-szjdLstd-index-table-2C6Dc"};


//////////////////
// WEBPACK FOOTER
// ./components/swbl/szjdLstd/index.css
// module id = 2299
// module chunks = 0